$(document).on 'click', 'body.apps a.scorecard, body.reviews a.scorecard', ()->
  link = $(this)
  options = link.attr('data-options')
  if options?
    m = window.get_modal_markup()
    m.load this.href.replace('new','scorecard'), ->
      m.html(
        window.get_modal_content(
          'Creating Interview Scorecard',
          m.html(),
          '<button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
           <a id="continue-button" href="' + link.attr('href') + '" class="btn btn-primary" target="_blank">Continue</a>'
        )
      )
      sc_select = m.find('#scorecard_id')
      sc_select.html(options)
      if sc_select.find('option').length < 2
        m.find('.choose-scorecard').hide()
      else
        sc_select.on 'change', ->
          href = m.find('#continue-button').attr('href')
          href = href.replace(/scorecard_id=(\d+)/,'scorecard_id=' + sc_select.val())
          m.find('#continue-button').attr('href', href)

      m.find('.scorecard-share input').change ->
        if $(this).prop('checked') && $(this).val() == '1'
          m.find('.share-to').collapse('show')
        else
          m.find('.share-to').collapse('hide')

      m.find('#continue-button').on 'click', ->
        if m.find('.share-to:visible').length < 1
          m.modal('hide')
          return true
        else
          m.find('form').submit()
          m.modal('hide')
          return false

      m.modal()
    return false
  return true

# Add scorecard class to container.main for scorecard views
$(->
  if $('div.container.main').has('div.sc-container').length > 0
    $('div.container.main').addClass('scorecard')
)

# Show/Hide V2 Scorecard Questions by Section
show_one = (to_show) ->
  $('.sc-section-questions, .sc-section-results').each ->
    q = $(this)
    if q.data('sid') == to_show.data('sid')
      q.show()
    else
      q.hide()

# Show first section only on page load
$(->
  first_sec = $('.sc-sections').find('.nav-link').first()
  show_one(first_sec)
  show_btn_unless_last(first_sec)
)

toggle_active = (elem) ->
  v_type = if elem.hasClass('nav-link') then '.dropdown-item' else '.nav-link'
  other_elem = $('.sc-sections').find(v_type).filter('[data-sid="' + elem.data('sid') + '"]')
  $('.sc-sections').find('.nav-link.active, .dropdown-item.active').removeClass('active')
  elem.addClass('active')
  other_elem.addClass('active')

show_btn_unless_last = (to_show) ->
  btn_div = $('.sc-content').find('.sc-next')
  save_btn = $('.form-actions').find('.sc-save')
  last_sec = $('.sc-sections').find('.nav-link').last()
  if to_show.data('sid') != last_sec.data('sid')
    btn_div.show()
    save_btn.hide()
  else
    btn_div.hide()
    save_btn.show()

$(document).on 'click', '.sc-container .sc-section a.nav-link, .sc-container .sc-mobile-nav .sc-sections a.dropdown-item', () ->
  to_show = $(this)
  return if to_show.hasClass('disabled')
  toggle_active(to_show)
  show_one(to_show)
  show_btn_unless_last(to_show)

# Scorecard Next Section & Save buttons
hide_next_if_last = (to_show, btn) ->
  last_sec = $('.sc-sections').find('.nav-link').last()
  save_btn = $('.form-actions').find('.sc-save')
  if to_show.data('sid') == last_sec.data('sid')
    btn.parent().hide()
    save_btn.show()
  else
    btn.parent().show()
    save_btn.hide()

$(document).on 'click', '.sc-container .sc-next a.next-section', () ->
  btn = $(this)
  current_sec = $('.sc-sections').find('.nav-link.active')
  to_show = current_sec.parent().next().children('.nav-link')
  toggle_active(to_show)
  show_one(to_show)
  hide_next_if_last(to_show, btn)

# Add block class to Next Section & Save buttons if mobile
toggle_block = (next_btn, save_btn) ->
  if $('.sc-mobile-nav').css('display') == 'flex'
    next_btn.addClass('btn-block')
    save_btn.addClass('btn-block')
  else
    next_btn.removeClass('btn-block')
    save_btn.removeClass('btn-block')

$(->
  next_btn = $('.sc-next a')
  save_btn = $('.sc-save')
  toggle_block(next_btn, save_btn)

  $(window).on 'resize', () ->
    toggle_block(next_btn, save_btn)
)

# Hidden divs for all option dropdowns for print visibility
$(->
  $('.container.main.scorecard select').each (i, el) ->
    sel = $(el)
    options = sel.find('option')
    sel.after("<div class='print-opts'><ul id=sel#{i}></ul></div>")
    to_print = $("#sel#{i}")
    options.each (i, opt) ->
      sopt = $(opt)
      if sopt.text() != ''
        to_print.append("<li>#{sopt.text()}</li>")
)
